import styles from './Default.module.css';

export const DefaultDropdown = ({
  children,
  className,
  dataTestid,
  ...rest
}) => {
  return (
    <section
      className={`dropdown-wrap ${styles.dropdown} ${className} `}
      data-testid={dataTestid}
      {...rest}
    >
      {children}
    </section>
  );
};
